var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"safe-width",attrs:{"id":"header"}},[_c('div',{attrs:{"id":"header-logo"}},[_c('img',{attrs:{"src":require("../img/logo.svg")},on:{"click":_vm.toHome}})]),_c('cvp-user',{attrs:{"c":"user primary medium"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }